import classNames from "classnames";
import React from "react";

interface Props {
  artistId: number
  isFavorite: boolean
}

const FavoriteIcon = (props: Props) => {
  const [isFavorite, setIsFavorite] = React.useState(props.isFavorite);

  const onToggle = () => {
    const newIsFavorite = !isFavorite;
    setIsFavorite(newIsFavorite);

    if (newIsFavorite) {
      window.CoreApi.FavoriteArtist.Add({ artistIds: [props.artistId] });
    } else {
      window.CoreApi.FavoriteArtist.Remove({ artistIds: [props.artistId] });
    }
  };

  const classes = classNames({
    "icon-favorite-on": isFavorite,
    "icon-favorite-off": !isFavorite
  });

  return <i
    className={classes}
    onClick={onToggle}
  />;
};

export default FavoriteIcon;